import { render, staticRenderFns } from "./AddLogistics.vue?vue&type=template&id=0a05e496&"
import script from "./AddLogistics.vue?vue&type=script&lang=js&"
export * from "./AddLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports